import React from 'react';
import { ChipTagProps } from 'typings';

export const ChipTag: React.FC<ChipTagProps> = ({ id, icon, color, value }) => {
    return (
        <bds-chip-tag id={id} icon={icon} color={color}>
            {value}
        </bds-chip-tag>
    );
};
